<template>
  <tile class="opc-basic-plus">
    <foldable v-model="isExpanded" :arrow="hasSelectedPlan" :edit="hasSelectedPlan" :title="title">
      <template #head>
      <div>
        <div class="flex-container header-container">
          <img class="opc-basic-plus__logo right-cel" :src="IconZM" alt="Zoom One" />
          <div class="left-cel">
            <div class="flex-container-header-right">
              <h1 class="opc-basic-plus__name">
                {{ title }}
                <!-- <i class="zm-icon-success main-icon" aria-hidden="true"></i> -->
              </h1>
              <zm-button data-testid="checkout-button-96" v-if="isExpanded" class="opc-basic-plus__link" type="link" @click="handleOpenPlanDetails">
                {{ $t('billing.plan_details') }}
              </zm-button>
            </div>
            <div class="flex-container">
              <span class="opc-basic-plus__info" v-if="selectedPlan" v-html="getPlanCollapseText()"></span>
            </div>
          </div>
        </div>
      </div>
      </template>
      <div class="opc-basic-plus__body flex-container">
        <div class="opc-basic-plus__body-item">
          <img class="opc-basic-plus__body-item-icon" :src="IconStopwatch" alt="">
          <div>
            <p class="opc-basic-plus__body-item-title">{{ $t('billing.zone_basic_plus.comments.extend_your_meetings') }}</p>
            <p class="opc-basic-plus__body-item-text">{{ $t('billing.zone_basic_plus.comments.extend_your_meetings_desc', [ZOBASICP_MEETING_MINUTES]) }}</p>
          </div>
        </div>
        <div class="opc-basic-plus__body-item">
          <img class="opc-basic-plus__body-item-icon" :src="IconCheckmark" alt="">
          <div>
            <p class="opc-basic-plus__body-item-title">{{ $t('billing.zone_basic_plus.comments.more_great_feature') }}</p>
            <p class="opc-basic-plus__body-item-text">{{ $t('billing.zone_basic_plus.comments.more_great_feature_desc', [ZOBASICP_CMR_STORAGE]) }}</p>
          </div>
        </div>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import plansMixin from '@/plans/mx/plan';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import IconZM from '@/assets/plans/icon_ZM.svg';
import IconCheckmark from '@/assets/plans/Checkmark.svg';
import IconStopwatch from '@/assets/plans/Stopwatch.svg';
import { mapGetters } from 'vuex';
import FullComparisonDialog from './dialog/full-comparison-dialog.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { pageConfig } from '@/common/service/page-config';
import { getPlanCollapseText } from '@/common/product';

const ZOBASICP_MEETING_MINUTES = pageConfig.zobasicp_meeting_minutes || 80;
const ZOBASICP_CMR_STORAGE = pageConfig.zobasicp_cmr_storage || 1;

export default {
  components: {
    Foldable,
    Tile,
  },
  mixins: [plansMixin],
  data() {
    return {
      isExpanded: true,
      title: this.$t('billing.zone_basic_plus.title'),
      hasSelectedPlan: false,
      IconZM,
      IconStopwatch,
      IconCheckmark,
      fullComparisonDialog: new ServiceConfirm(FullComparisonDialog),
      form: {
        license: 1,
        billing_cycle: BILLING_CYCLE.MONTHLY,
      },
      ZOBASICP_MEETING_MINUTES,
      ZOBASICP_CMR_STORAGE,
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPlan() {
      return this.getSelectedPlans.find(item => item.type === planTypes.ZONE_BASIC_PLUS);
    },
  },
  methods: {
    async handleOpenPlanDetails() {
      try {
        await this.fullComparisonDialog.confirm();
      } catch (e) {
        return null;
      }
    },
    getPlanCollapseText() {
      return getPlanCollapseText({
        amount: this.selectedPlan?.amount,
        billingCycle: this.selectedPlan?.billing_cycle,
        quantity: 1,
        cycleValue: this.selectedPlan?.cycleValue,
        unit: this.selectedPlan?.unit,
      });
    }
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-basic-plus {
  &.opc-tile {
    padding: 0;
    border-radius: 16px;
    overflow: hidden;
  }
  .flex-container {
    display: flex;
    align-items: center;

    .left-cel {
      width: 100%;
    }

    .flex-container-header-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .header-container {
    padding: 24px;
  }
  .main-icon {
    color: $theme-color;
  }
  &__name {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    @include media(mobile,tablet){
     width: 200px;
    }
  }
  &__logo {
    width: 44px;
    height: 44px;
    margin-right: 16px;
  }
  &__link {
    padding: 0;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #0B5CFF;
  }
  &__info {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    margin-right: 13px;
  }
  &__body {
    // background: #F7F7F8;
    background: var(--zoom-color-fill-subtler-neutral, #F7F9FA);
    &-item {
      display: flex;
      padding: 37px 23px 48px 33px;
      justify-content: center;
      &-icon {
        margin-top: 5px;
        width: 25px;
        height: 25px;
        margin-right: 6px;
      }
      &-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      }
      &-text {
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: 0.01em;
        text-align: left;
        color: var(--zoom-color-text-strong-neutral, #555B62);
      }
    }
  }
}
</style>
